<template>
  <div id="" class="mainDiv">
    <h2>请长按识别二维码进行</h2>
    <h2>关注公众号绑定签到~~</h2>
    <img class="qrcodeimg" :src="qrcodeimg" alt="" />
    <p class="p">华南理工大学继续教育学院公众号</p>
  </div>
</template>

<script>
import Img from '@/static/images/qrcode.jpg'
import devImg from '@/static/images/dev_qrcode.jpg'
export default {
  name: 'GongzhonghaoQrcode',
  data() {
    return {
      img: Img,
      devImg,
    }
  },
  methods: {
    // tab切换
    handleClick() {
      this.pageObj.page = 1
      // this.getList()
    },
    goBack() {
      window.history.go(-1)
    },
  },
  created() {},
  computed: {
    getUId() {
      return localStorage.getItem('uid') 
    },
    qrcodeimg() {
      let img = ''
      let url = window.location.host
      if (url === 'fxl.sce.scut.edu.cn') {
        img = this.Img
      } else {
        img = this.devImg
      }
      return img
    },
  },
}
</script>

<style lang="scss" scoped>
.qrcodeimg {
  width: 50%;
  position: relative;
  left: 50%;
  transform: translateX(-50%);
}
h2 {
  text-align: center;
}
.p {
  text-align: center;
}
</style>
